import { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Calendar } from 'lucide-react';
import DataNotFound from '../ui/loader/data-not-found';
import { ChartMainCard } from '../LeadsDashboardComponents/ChartsHeader';
import { TeamAvailability } from '../LeadsDashboardComponents/StatCardIcons';

export function ProjectsByProducts({ apiData = [], apiLoading }) {

  // 🎨 Dynamic color palette (auto supports many items)
  const colors = [
    '#3b82f6',
    '#a855f7',
    '#f59e0b',
    '#10b981',
    '#ef4444',
    '#6366f1',
    '#14b8a6',
    '#f43f5e',
    '#84cc16',
  ];

  const labels = useMemo(
    () => apiData.map(item => item.product),
    [apiData]
  );

  const series = useMemo(
    () => apiData.map(item => item.count),
    [apiData]
  );

  const chartOptions = useMemo(() => ({
    chart: {
      type: 'donut',
      height: 200,
    },
    labels,
    colors: colors.slice(0, labels.length),
    dataLabels: { enabled: false },
    legend: { show: false },
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
        },
      },
    },
    stroke: {
      width: 2,
      colors: ['#fff'],
    },
    tooltip: {
      y: {
        formatter: (val) => val.toLocaleString(),
      },
    },
  }), [labels]);

  if (apiLoading) {
    return (
      <div className="p-6 text-gray-500 text-sm">
        Loading...
      </div>
    );
  }

  return (
    <ChartMainCard
      Icon={<TeamAvailability />}
      iconColor={'bg-theme-blue-light text-theme-blue'}
      heading="Product-wise Projects Analysis"
      subHeading={"High-level view of project by product"}
    >

      {
        apiData.length > 0 ? (
          <div className="px-6 flex-1 flex flex-col max-h-[460px]">

            {/* Donut */}
            <div className="flex-1 flex items-center justify-center mb-6">
              <div className="w-full" style={{ maxWidth: '300px' }}>
                <ReactApexChart
                  options={chartOptions}
                  series={series}
                  type="donut"
                  height={200}
                />
              </div>
            </div>

            {/* Dynamic Status List */}
            <div className='h-full overflow-hidden flex flex-col'>
              <h6 className="mb-3 font-semibold text-base">Products</h6>
              <div className="space-y-2 !h-full overflow-auto">
                {apiData.map((item, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <p className="text-sm flex items-center gap-2">
                      <span
                        className="w-3 h-3 rounded-full"
                        style={{ backgroundColor: colors[index % colors.length] }}
                      ></span>
                      {item.product}
                    </p>
                    <p className="text-sm font-semibold text-gray-900">
                      {item.count}
                    </p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        ) :
          <DataNotFound title={"Product Data"} />
      }
    </ChartMainCard>



  );
}
